import { basePathIcons, SvgIcon } from '@y42/core/icon';

const iconsBasePath = `${basePathIcons}/miscellaneous`;

export const warningIcon: SvgIcon = `${iconsBasePath}/warning.svg`;
export const checkRound: SvgIcon = `${iconsBasePath}/check-round.svg`;
export const errorFilled: SvgIcon = `${iconsBasePath}/error-filled.svg`;
export const loadingIcon: SvgIcon = `${iconsBasePath}/loading.svg`;
